import { render, staticRenderFns } from "./LineLeaderBaseButton.vue?vue&type=template&id=15682970&scoped=true&"
import script from "./LineLeaderBaseButton.vue?vue&type=script&lang=ts&"
export * from "./LineLeaderBaseButton.vue?vue&type=script&lang=ts&"
import style0 from "./LineLeaderBaseButton.vue?vue&type=style&index=0&id=15682970&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15682970",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VRow})
